import { apiSlice } from '../../api';
import type { GetRatesResult, GetRatesDTO } from './types';

const ratesEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getRates: build.query<GetRatesResult, GetRatesDTO>({
      query: (params) => ({
        url: '/admin/v1/rates',
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useGetRatesQuery, useLazyGetRatesQuery } = ratesEndpoints;

export type RatesController = typeof ratesEndpoints;
